export default __webpack_public_path__ + "static/media/water-leak.2c9369dd.svg";